module.exports = __webpack_public_path__ + "static/img/1667305381156854.5a387eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy/1667305381156854.jpg
// module id = 8ur2
// module chunks = 4